import { render } from "./backdrop.vue?vue&type=template&id=5828d3c9"
import script from "./backdrop.vue?vue&type=script&lang=js"
export * from "./backdrop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__